import LoginData from './LoginData'

export default LoginData
